import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
  DashboardCard,
  IProtectAndSave,
  IStrapiDocument,
} from '../../../../interfaces/strapi';
import StrapiService from '../../../../services/strapi.service';
import { VerticalCarouselComponent } from '../../../../shared/components/vertical-carousel/vertical-carousel.component';
import { ProtectAndSaveCarouselSlideComponent } from '../protect-and-save-carousel-slide/protect-and-save-carousel-slide.component';
import { SliderComponentComponent } from '../../../../shared/components/slider-component/slider-component.component';

@Component({
    selector: 'app-protect-and-save-dashboard-component',
    templateUrl: './protect-and-save-dashboard-component.component.html',
    styleUrls: ['./protect-and-save-dashboard-component.component.scss'],
    imports: [
        VerticalCarouselComponent,
        ProtectAndSaveCarouselSlideComponent,
        SliderComponentComponent,
    ],
})
export class ProtectAndSaveDashboardComponentComponent implements OnInit {
  @Input() public carousel: DashboardCard[] = [];

  public pageData: IProtectAndSave = <IProtectAndSave>{};

  constructor(
    public readonly strapi: StrapiService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.strapi
      .getProtectAndSave()
      .subscribe((data: IStrapiDocument<IProtectAndSave>) => {
        Promise.resolve().then(() => {
          this.pageData = data.data.attributes;
          this.cdr.detectChanges();
        });
      });
  }
}
